import { Calendar, getCalendarEntry } from 'owa-calendar-cache';
import {
    CalendarProviderType,
    isCalendarFolderSyncedByCalendarProvider,
    isCalendarProviderAccountUnauthorized,
} from 'owa-calendar-provider-accounts-store';

import type { CalendarPickerCalendarLoadingState } from '../store/schema/CalendarPickerCalendarLoadingState';
import { getCalendarLoadState } from 'owa-calendar-surface-calendars-load-state';

export default function getCalendarLoadingState(
    calendar: Calendar
): CalendarPickerCalendarLoadingState {
    let state: CalendarPickerCalendarLoadingState = getCalendarLoadState(calendar.id.id);

    const calendarEntry = getCalendarEntry(calendar);
    if (
        isCalendarFolderSyncedByCalendarProvider(calendarEntry) &&
        isCalendarProviderAccountUnauthorized(calendarEntry.ProviderId as CalendarProviderType)
    ) {
        // If the calendar is synced by a calendar provider and we have the account unauthorized then
        // returns the state as unauthorized
        state = 'CalendarProviderUnauthorized';
    }

    return state;
}
